export default __webpack_public_path__ + "static/media/rightarrows.45d67105.svg";